import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b1dd3de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "route-service-filter" }

import { onMounted, ref, watch } from 'vue'
import BaseSelect from '@/components/BaseSelect.vue'
import { Option } from '@/models/shared.model'
import { fetchSearchCategories } from '@/queries/categories'
import { useRoutePlanningServicesMutation } from '@/queries/public/services'
import { getOptionKeys } from '@/utils/general'
import { debounce } from 'lodash'
import { useFilterStore } from '@/store/filter'
import { ROUTE_PLANNER_FILTERS } from '@/enums/services'


export default /*#__PURE__*/_defineComponent({
  __name: 'RouteServiceFilter',
  emits: ['onChange'],
  setup(__props, { emit: emits }) {


const { mutateAsync: fetchServices } = useRoutePlanningServicesMutation()
const debouncedFetchServices = debounce(handleFetchServices, 400)
const { routeServiceFilter, updateRouteServiceFilters } = useFilterStore()

const searchCategoryOptions = ref<Option[]>([])
const selectedSearchCategories = ref<Option[]>([])

const removeOption = (option: Option) => {
  selectedSearchCategories.value = selectedSearchCategories.value.filter(
    (o) => o.key !== option.key,
  )
}

async function handleFetchServices() {
  try {
    const searchResults = await fetchServices(routeServiceFilter.filters)
    emits('onChange', searchResults)
  } catch (e) {
    console.error(e)
  }
}

onMounted(async () => {
  const data = await fetchSearchCategories()
  searchCategoryOptions.value = data.map((searchCategory) => ({
    key: searchCategory.id,
    label: searchCategory.name,
  }))
})

watch(
  () => selectedSearchCategories.value,
  () => {
    updateRouteServiceFilters(
      String(getOptionKeys(selectedSearchCategories.value)),
      ROUTE_PLANNER_FILTERS.SEARCH_CATEGORIES,
    )
    debouncedFetchServices()
  },
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseSelect, {
      modelValue: selectedSearchCategories.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedSearchCategories).value = $event)),
      label: _ctx.$t('category'),
      options: searchCategoryOptions.value,
      multiple: true,
      "return-object": true,
      onRemove: removeOption
    }, null, 8, ["modelValue", "label", "options"])
  ]))
}
}

})